import { render, staticRenderFns } from "./ChooseInitializeCommunity.vue?vue&type=template&id=8ca1c636"
import script from "./ChooseInitializeCommunity.vue?vue&type=script&lang=js"
export * from "./ChooseInitializeCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports